import React, { useEffect } from 'react';
import DocSearchImportContainer from "./DocSearchImportContainer"
import withView from '../../../docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormMenu from '../../../../../library/form/components/FormMenu';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const DocSearchDefActions = (props) => {
    const { formObject, selectedDids, reloadSearch, deviceInfo } = props;

    const initialiseActions = () => {
        // console.log("custom action set", formObject.dataList);
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch(1);
    }

    useEffect(initialiseActions, [props.viewData]);

    const renderImportTrigger = () => {
        const viewData = formObject.getFormData("", "qaRow", "import");
        const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
        const importTpl = formObject.getValueFromKey(viewData, "dataList.importTpl", "0");

        if(hide === '0')
        {
            return(
                <DocSearchImportContainer importTpl={importTpl} />
            )
        }
    }

    return (
        <>
            <FormMenu formObject={formObject}
                customWrapper="div"
                rowKey="" headerKey='batchAction' starIcon={'adds'} endIcon={'arrowmenu'} 
                endIconClassName='uiBrandColor1'
                text="Batch Action" 
                action={{isBatchAction: 1, dIds:selectedDids.join(","), containerKey:"redirect"}}
                className="" />
            {renderImportTrigger()}
            <FormMenu formObject={formObject}
                customWrapper="div"
                rowKey="" headerKey='print' starIcon={'print'} 
                text="Print" 
                action={{}}
                className="" />
            <FormButton formObject={formObject} headerKey="qaRow" 
                rowKey="" tooltip='Export Data' ksc="e"
                action={{ actionId: "cancel",  paramName: "export" }}
                className="uiActionButton" text={<SarasTrans value="Export Data" />}></FormButton>

            <FormButton formObject={formObject} headerKey="qaRow" 
                starIcon="addq"
                onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                rowKey="" ksc="q"
                action={{ actionId: 'new',  paramName: "quickAdd",  containerKey: "popup",
                onModalClose: onPopupClose,
                actionParam:{"viewCaller":"InSearch","dtId":"%headerRows.quickActionRow.quickAdd.dataList.docTypeId","showModeID":"sh"} }}
                className="uiActionButton" text={<SarasTrans value="Quick Add" />}></FormButton>

            <FormButton formObject={formObject} headerKey="qaRow" 
                starIcon="adds"
                customWrapper="div"
                onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                rowKey="" ksc="n"
                action={{ actionId: "new",  paramName: "createNew", containerKey:"redirect" }}
                className="uiActionButton" text={<SarasTrans value={`Create New`} />}></FormButton>
        </>
    )
}

export default withView(DocSearchDefActions, '', '', 0);
